module.exports = __webpack_public_path__ + "img/playericon.5f9c7980.png";